import React from 'react';
import { useParams } from 'react-router-dom';
import { SpeechStream } from '@twigeducation/speechstream';
import ReadSpeaker from '../../components/ReadSpeaker';
import AssetGlossaryPage from './AssetGlossaryPage';
import AssetPage from './AssetPage';

const SpeechStreamWithStartingPoints = props => (
    <SpeechStream {...props} startingPoints={['termModalBody']} autoPlay showFixedToolbar />
);

const AssetPageRedirect = props => {
    const { type } = useParams();
    if (type === 'glossary-term')
        return <AssetGlossaryPage {...props} ReadSpeaker={ReadSpeaker} SpeechStream={SpeechStreamWithStartingPoints} />;
    return <AssetPage {...props} />;
};

export default AssetPageRedirect;
